import { Observable } from 'rxjs';
import { ClinicPosition, DataSourceResponse } from '../../models';
import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { HttpParamsEncoder } from '../../tools';


@Injectable({ providedIn: 'root' })
export class ClinicPositionService extends ApiService {
  endPoint = '/api/clinicPositions';

  create(model: ClinicPosition) {
    return this.http.post(`${this.clinicsBaseURL}${this.endPoint}`, model);
  }

  update(id: string, model: ClinicPosition) {
    return this.http.put(`${this.clinicsBaseURL}${this.endPoint}/${id}`, model);
  }

  delete(id: string) {
    return this.http.delete<any>(`${this.clinicsBaseURL}${this.endPoint}/${id}`);
  }

  deleteRange(ids: string[]) {
    return this.http.post<any>(`${this.clinicsBaseURL}${this.endPoint}/deleteRange`, ids);
  }

  get(id: string): Observable<ClinicPosition> {
    return this.http.get<ClinicPosition>(`${this.clinicsBaseURL}${this.endPoint}/${id}`);
  }

  getList(queryParams: any): Observable<DataSourceResponse<ClinicPosition>> {
    const params = new HttpParamsEncoder().encode(queryParams);
    return this.http.get<any>(`${this.clinicsBaseURL}${this.endPoint}`, { params });
  }
}
